if (!customElements.get('media-gallery')) {
  customElements.define('media-gallery', class MediaGallery extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        liveRegion: this.querySelector('[id^="GalleryStatus"]'),
        viewer: this.querySelector('[id^="GalleryViewer"]'),
        thumbnails: this.querySelector('[id^="GalleryThumbnails"]')
      }
      this.mql = window.matchMedia('(min-width: 750px)');
      this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
      this.elements.thumbnails?.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
        mediaToSwitch.querySelector('button').addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
      });
      if (this.dataset.desktopLayout !== 'stacked' && this.mql.matches) this.removeListSemantic();
      const sectionId = this.id.replace('MediaGallery-', '');
      const variantId = document.querySelector(`#product-form-${sectionId} input[name="id"]`)?.value;
      const activeId = this.elements.viewer.querySelector('[data-media-id].is-active')?.dataset.mediaId;
      if (this.dataset.variantGallery === 'true') {
        this.querySelectorAll('img[alt]').forEach((image) => {
          image.alt = image.alt.replace(/^\[(variant:\d+|shared)\]\s*/i, '');
        });
      } else if (variantId) {
        this.setVariantMedia(variantId, activeId, true);
      }
    }

    setVariantMedia(variantId, featuredMediaId, isInitial = false) {
      const slides = [...this.elements.viewer.querySelectorAll('[data-media-id]')];
      slides.forEach((slide) => {
        if (slide.dataset.galleryGroupParsed) return;
        const image = slide.querySelector('img');
        const marker = image?.alt?.trim().match(/^\[(variant:\d+|shared)\]\s*/i);
        slide.dataset.galleryGroup = marker ? marker[1].toLowerCase() : '';
        slide.dataset.galleryGroupParsed = 'true';
        if (image && marker) image.alt = image.alt.replace(/^\[(variant:\d+|shared)\]\s*/i, '');
        const thumbImage = this.elements.thumbnails?.querySelector(`[data-target="${slide.dataset.mediaId}"] img`);
        if (thumbImage && marker) thumbImage.alt = thumbImage.alt.replace(/^\[(variant:\d+|shared)\]\s*/i, '');
      });
      const grouped = slides.some((slide) => slide.dataset.galleryGroup.startsWith('variant:'));
      const hasMatch = slides.some((slide) => slide.dataset.galleryGroup === `variant:${variantId}`);
      // Untagged products keep the theme's original featured-image behavior.
      if (!grouped) {
        if (!isInitial && featuredMediaId) this.setActiveMedia(featuredMediaId, true);
        return;
      }
      const visible = [];

      slides.forEach((slide) => {
        const group = slide.dataset.galleryGroup;
        const show = !grouped || !hasMatch || group === `variant:${variantId}` || group === 'shared';
        slide.hidden = !show;
        if (show) slide.classList.remove('product__media-item--variant');
        slide.style.display = show ? '' : 'none';
        const thumb = this.elements.thumbnails?.querySelector(`[data-target="${slide.dataset.mediaId}"]`);
        if (thumb) {
          thumb.hidden = !show;
          if (show) thumb.classList.remove('thumbnail-list_item--variant');
          thumb.style.display = show ? '' : 'none';
          if (thumb.querySelector('button')) thumb.querySelector('button').tabIndex = show ? 0 : -1;
        }
        if (show) {
          visible.push(slide);
          if (thumb) thumb.dataset.mediaPosition = String(visible.length);
        }
      });

      const active = visible.find((slide) => slide.dataset.mediaId === featuredMediaId) || visible[0];
      if (!active) return;
      this.setActiveMedia(active.dataset.mediaId, !hasMatch);
      this.elements.viewer.resetPages?.();
      this.elements.thumbnails?.resetPages?.();
      const total = this.elements.viewer.querySelector('.slider-counter--total');
      if (total) total.textContent = String(visible.length);
      const current = this.elements.viewer.querySelector('.slider-counter--current');
      if (current) current.textContent = String(visible.indexOf(active) + 1);
    }

    onSlideChanged(event) {
      if (!event.detail.currentElement) return;
      const thumbnail = this.elements.thumbnails?.querySelector(`[data-target="${ event.detail.currentElement.dataset.mediaId }"]`);
      this.setActiveThumbnail(thumbnail);
    }

    setActiveMedia(mediaId, prepend) {
      const activeMedia = this.elements.viewer.querySelector(`[data-media-id="${ mediaId }"]`);
      this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
        element.classList.remove('is-active');
      });
      if (!activeMedia) return;
      activeMedia.classList.add('is-active');
      
      if (prepend) {
        activeMedia.parentElement.prepend(activeMedia);
        if (this.elements.thumbnails) {
          const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${ mediaId }"]`);
          if (activeThumbnail) activeThumbnail.parentElement.prepend(activeThumbnail);
        }
        if (this.elements.viewer.slider) this.elements.viewer.resetPages();
      }

      this.preventStickyHeader();
      window.setTimeout(() => {
        if (this.elements.thumbnails) {
          activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
        }
        if (!this.elements.thumbnails || this.dataset.desktopLayout === 'stacked') {
          activeMedia.scrollIntoView({behavior: 'smooth'});
        }
      });
      this.playActiveMedia(activeMedia);

      if (!this.elements.thumbnails) return;
      const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${ mediaId }"]`);
      this.setActiveThumbnail(activeThumbnail);
      if (activeThumbnail) this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
    }

    setActiveThumbnail(thumbnail) {
      if (!this.elements.thumbnails || !thumbnail) return;
      this.elements.thumbnails.querySelectorAll('button').forEach((element) => element.removeAttribute('aria-current'));
      thumbnail.querySelector('button').setAttribute('aria-current', true);
      if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

      this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
    }

    announceLiveRegion(activeItem, position) {
      const image = activeItem.querySelector('.product__modal-opener--image img');
      if (!image) return;
      image.onload = () => {
        this.elements.liveRegion.setAttribute('aria-hidden', false);
        this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace(
          '[index]',
          position
        );
        setTimeout(() => {
          this.elements.liveRegion.setAttribute('aria-hidden', true);
        }, 2000);
      };
      image.src = image.src;
    }

    playActiveMedia(activeItem) {
      window.pauseAllMedia();
      const deferredMedia = activeItem.querySelector('.deferred-media');
      if (deferredMedia) deferredMedia.loadContent(false);
    }

    preventStickyHeader() {
      this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
      if (!this.stickyHeader) return;
      this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
    }

    removeListSemantic() {
      if (!this.elements.viewer.slider) return;
      this.elements.viewer.slider.setAttribute('role', 'presentation');
      this.elements.viewer.sliderItems.forEach(slide => slide.setAttribute('role', 'presentation'));
    }
  });
}
